<template>
  <div>
    <HeaderBreadcrumbs
  :items="[
    { label: 'Accounts', to: '/customers/list' },
    { label: (User[0]?.first_name && User[0]?.last_name) ? User[0].first_name + ' ' + User[0].last_name : 'Detail User' }
  ]"
  :title="(User[0]?.first_name && User[0]?.last_name) ? User[0].first_name + ' ' + User[0].last_name : 'Detail User'"
/>
<div  v-if="User?.length > 0" class="bg-white p-0 my-3 rounded-lg shadow-sm">
  <Profile :user="User[0]" :userBannedDetailUserId="userBannedDetailUserId" />
</div>
<div v-if="User[0]?.devices.length > 0">
    <TableDevice 
    :User="User" 
    :id="$route.params.id"  
     />
</div>
<div v-else>
  <div class="overflow-x-auto rounded-lg shadow-sm mb-4 bg-white px-4">
    <h4 class="text-xl font-bold pt-3 pb-2">Logged Device Details</h4>
    <div  v-if="!isLoading" class="relative overflow-x-auto my-2 mb-4 rounded-lg  border-gray-200 border-b border-t border-r border-l">
  <table class="min-w-full text-sm rounded-lg text-left">
        <thead class="bg-gray-50 text-gray-700">
          <tr class="text-center">
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">No</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Device ID</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Device Type</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">IMEI</th>
            <th class="px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b">Last Modified Date</th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr>
            <td colspan="5" class="text-center py-8 text-gray-500">
             <div class="flex-col items-center justify-center flex-nowrap flex">
            <svg class="w-14 h-14 text-gray-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z" />
            </svg>
            <h4 class="text-base text-gray-600 mb-0">No Data</h4>
            <p class="text-sm text-gray-500">There are no data to display</p>
          </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    </div>
</div>
<div class="shadow-md bg-white rounded-lg p-4 h-custom">
    <h4 class="font-bold text-xl leading-7 mb-4 block">Accounts Details</h4>
    <div class="tabs-container border-b border-gray-300">
    <ul class="flex space-x-6 text-sm font-medium">
      <li
        v-for="(tab, index) in tabs"
        :key="index"
        @click="handleTabs(tab)"
        :class="[
          selectedTab === tab.name ? 'text-blue-600' : 'text-gray-500',
          'cursor-pointer'
        ]"
        class="relative"
      >
      <div class="absolute top-9 w-full"
      :class="[
          selectedTab === tab.name ? 'text-blue-600 border-blue-600 border-b' : 'text-gray-500',
          'cursor-pointer'
        ]"
      > </div>
        {{ tab.name }}
      </li>
    </ul>
  </div>
  <div v-if="selectedTab === 'Reading Time History'">
         <reading v-if="User[0] && User[0].id" :id="User[0].id" :from="from" :to="to" />
    </div>
  <div v-else-if="selectedTab === 'Transaction'" >
    <OrderTable 
    :items="items" 
    :id="this.$route.params.id" 
    :isLoading="isLoadingOrders"
    :perPage="this.perPageTransaction" 
    @sort-data="sortData" 
    :currentPage="currentPageTransaction" 
    />
               
    <div v-if="rowsTransaction / perPageTransaction > 1">
      <div class="flex justify-between ml-1 px-0 items-stretch align-middle flex-wrap ">
        <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPageTransaction }}-{{ perPageTransaction }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(rowsTransaction) }}
          </div>
          <div class="">
            <t-pagination :total-items="Number(rowsTransaction)" :per-page="perPageTransaction" v-model="currentPageTransaction" class="rounded-lg" />
          </div>
      </div>
    </div>

    </div>

    <div v-else-if="selectedTab === 'Buffets'">
      <Buffets 
      :user="this.$route.params.id" 
      :buffets="buffets" 
      :isLoading="isLoadingBuffets" 
      :perPage="this.perPageBuffets" 
       @sort-data="sortData" 
      :currentPage="currentPagrBuffets"
      />
      
      <div v-if="rowBuffets / this.perPageBuffets > 1">
      <div class="flex justify-between ml-0 px-0 items-stretch align-middle flex-wrap ">
        <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPagrBuffets }}-{{ perPageBuffets }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(rowBuffets) }}
          </div>
          <div class="">
            <t-pagination :total-items="Number(rowBuffets)" :per-page="perPageBuffets" v-model="currentPagrBuffets" class="rounded-lg" />
          </div>
      </div>
    </div>
    </div>

    <div v-else-if="selectedTab === 'Subscription'">
      <Subscription 
        :user="this.$route.params.id" 
        :subscription="subscription" 
        :isLoading="isLoading"
        :perPage="perPageScubcription" 
        @sort-data="sortData" 
        :currentPage="currentPageSubcription"
      />
    
      <div class="mt-3" v-if="totalRowsSubcription / this.perPageScubcription > 1">
      <div class="flex justify-between ml-0 px-0 items-stretch align-middle flex-wrap ">
        <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPageSubcription }}-{{ perPageScubcription }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRowsSubcription) }}
          </div>
          <div class="">
            <t-pagination :total-items="Number(totalRowsSubcription)" :per-page="perPageScubcription" v-model="currentPageSubcription" class="rounded-lg" />
          </div>
      </div>
    </div>
    </div>

    <div v-else-if="selectedTab === 'Single'">
      <Single 
      :user="this.$route.params.id" 
      :UserItems="UserItems" 
      :isLoading="isloadingUserItem"
      :perPage="perPageSingle" 
      @sort-data="sortData" 
      @switch-change="handleSwitchChange"
      @handle-filter="handleFiller"
      @reset-filter="handleReset"
      :currentPage="currentPageSingle"
      />

      <div class="mt-3" v-if="countSingle / perPageSingle > 1">
      <div class="flex justify-between ml-1 px-0 items-stretch align-middle flex-wrap ">
        <div class="font-semibold">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPageSingle }}-{{ perPageSingle }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(countSingle) }}
          </div>
          <div class="">
            <t-pagination  :total-items="Number(countSingle)" :per-page="perPageSingle" v-model="currentPageSingle" class="rounded-lg" />
          </div>
      </div>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { CustomersPath } from "../../router/customers";
import moment from "moment";
import Profile from "./profile.vue"
import reading from "./reading.vue"
import Subscription from "./subscription.vue";
import Buffets from "./buffets.vue";
import OrderTable from "../orders/table.vue"
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import TableDevice from './components/table.vue'
import Single from "./singleNew.vue"
// import ItunesPayment from "./itunes.vue"
export default {
  name: "Usersdetails",
  components: {
    OrderTable,
    HeaderBreadcrumbs,
    Buffets,
    TableDevice,
    reading,
    Subscription,
    Profile,
  //  ItunesPayment,
    Single
  },
  data() {
    
    return {
      CustomersPath,
      email: null,
      modal: false,
      perPageTransaction: 15,
      currentPageTransaction: 1,
      currentPagrBuffets:1,
      currentPageSubcription:1,
      perPageScubcription:15,
      perPageBuffets:15,
      currentPageSingle:1,
      perPageSingle:15,
      premiumFilter:null,
      isFetching: false,
      selectAllTypeContent:true,
      sort:[],
      date: new Date().toString,
      show: false,
      details: {},
      BuffetsDetail: {},
      tabs: [
        { name: 'Reading Time History' },
        { name: 'Transaction' },
        { name: 'Buffets' },
        { name: 'Subscription' },
        { name: 'Single' },
      ],
      selectedTab: 'Reading Time History',
    
      loadingAction: false,
      from: "2021-01-01",
      headers: [
        { label: 'No', key: 'no' },
        { label: 'DEVICE ID', key: 'device_id' },
        { label: 'DEVICE TYPE', key: 'device_model' },
        { label: 'IMEI', key: 'ip_address' },
        { label: 'LAST MODIFIED', key: 'modified' }
      ],
      to: moment().format("YYYY-MM-DD"),
      fields: [
        { key: 'No', label: 'No' },
        { key: 'product_id', label: 'Product' },
        { key: 'quantity', label: 'Quantity' },
        { key: 'transaction_id', label: 'Transaction Id' },
        { key: 'original_transaction_id', label: 'Original Transaction Id' },
        { key: 'purchase_date', label: 'Purchase Date', sortable: true, variant: 'info' },
        { key: 'expires_date', label: 'Expire date' },
        { key: 'in_app_ownership_type', label: 'In app' },

      ]
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.users.isLoading,
      isLoadingItunes: (state) => state.users.isLoadingItunes,
      isLoadingOrders: (state) => state.orders.isLoading,
      items: (state) => state.order.items,
      buffets: (state) => state.users.buffets,
      subscription: (state) => state.users.subscription,
      userBannedDetailUserId: (state) => state.users.userBannedDetailUserId,
      message: (state) => state.buffets.message,
      User: (state) => state.users.User,
      itunes: (state) => state.users.itunes,
      UserItems: (state) => state.users.UserItem,
      rowsTransaction: (state) => state.orders.totalRows,
      rowBuffets: (state) => state.users.totalRows,
      totalRowsSubcription: (state) => state.users.totalRowsSubcription,
      isLoadingBuffets: (state) => state.users.isLoadingBuffet,
      countSingle: (state) => state.users.countSingle,
      isloadingUserItem: (state) => state.users.isloadingUserItem
    }),
    ...mapGetters("orders", { items: "orders" }),
  },
  mounted() {
    let email = this.$route.params.id;
    this.email = email;
    //this.actionGetBuffet();
   this.actionGetUser(email);
  },
  watch: {
    currentPageTransaction: function () {
      this.actionGetOrder();
    },
    currentPageSingle: function () {
      this.actionGetSingle();
    },
    currentPagrBuffets: function () {
      this.actionGetBuffet();
    },
    currentPageSubcription: function () {
      this.actionShowSubscription();
    },
  },
  methods: {
    ...mapActions("users", ["fetchUserByid", "fetchBuffets", "fetchUserSubscription", "fetchSingle", "fetchItunes"]),
    ...mapActions("orders", ["fetchOrdersByEmail"]),
    ...mapActions("buffets", [
      "postBuffetByOrderID",
      "buffetDelete",
      "updateBuffetByid",
    ]),
    async actionGetOrder() {
      let payload = {
        page: this.currentPageTransaction,
        limit: this.perPageTransaction,
        email: this.$route.params.id,
      ...(this.sort && { sort: this.sort })
      };
      this.fetchOrdersByEmail(payload);
    },
    showTransaction() {
      let email = this.$route.params.id;
      this.actionGetOrder(email);
    },
    handleTabs(paramTabs) {
  if (this.selectedTab === paramTabs.name) return;

  this.selectedTab = paramTabs.name;

  const tabActions = {
    'Transaction': this.showTransaction,
    'Buffets': this.actionShowBuffet,
    'Subscription': this.actionShowSubscription,
    'Single': this.actionShowSingle,
  };

  const action = tabActions[paramTabs.name];
  if (action) action.call(this);
},
   
    actionShowSingle() {
      this.actionGetSingle();
    },

    actionShowBuffet() {
      this.actionGetBuffet()
    },
    actionShowSubscription() {
      this.actionSubscription()
    },
    actionGetBuffet() {
      let email = this.$route.params.id;
      let data = {
        email: email,
        page: this.currentPagrBuffets,
        limit: this.perPageBuffets,
        ...(this.sort && { sort: this.sort })
      };
      
      this.fetchBuffets(data);
    },
    actionSubscription() {
      let email = this.$route.params.id;
      let data = {
        email: email,
        page: this.currentPageSubcription,
        limit: this.perPageScubcription,
        ...(this.sort && { sort: this.sort })
      };
      this.fetchUserSubscription(data);
    },
   async actionGetSingle() {
    
      if (this.isFetching) return; 
      this.isFetching = true;
      try {
        let email = this.$route.params.id;
        let data = {
          email,
          limit: this.perPageSingle,
          page: this.currentPageSingle,
          ...(this.sort && { sort: this.sort }),
          premium: this.premiumFilter ? (this.premiumFilter === 'buffet' ? true : false) : null,
          selectAll: this.selectAllTypeContent,
        };
        await this.fetchSingle(data);
      } finally {
        this.isFetching = false;
      }
  },
    actionGetItunes(email) {
      let payload = {
        email: email,
      }
      this.fetchItunes(payload)
    },
    formatDate(tgl) {
      return moment(tgl).format("YYYY MMM DD HH:mm:ss A");
    },
     handleSwitchChange() {
       this.actionGetSingle()
      },
      handleFiller(contentType) {
        this.currentPageSingle = 1;
        this.premiumFilter = contentType
        this.selectAllTypeContent = (this.premiumFilter === 'all');
         this.actionGetSingle();
      },
      handleReset() {
         this.premiumFilter = null
         this.selectAllTypeContent = true
         this.actionGetSingle();
      },
    actionGetUser() {
      let payload = {
        id: this.$route.params.id,
      }
      this.fetchUserByid(payload)

    },
    actionShow() {
      this.actionGetUser()
    },
    formatPrice(value, currency) {
      if (value) {
        let formatter = null;
        if (currency == "USD") {
          formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency,
          });
        } else {
          formatter = new Intl.NumberFormat("en-ID", {
            style: "currency",
            currency: currency,
          });
        }

        return formatter.format(value);
      }

      return "0";
    },
    sortData(sort) {
        this.sort = sort
        this.actionGetSingle()
    },
    actionDetail(item) {
      if (this.details) {
        if (this.details.id === item.id) {
          this.show = false;
          this.details = {};
        } else {
          this.show = true;
          this.details = item;
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    async ExecutePatchOrder(line) {
      try {
        this.loadingAction = true;
        let payload = {
          id: line.order_id,
          orderline_id: line.id,
        };
        let response = await this.postBuffetByOrderID(payload);
        if (response) {
          this.loadingAction = false;
          this.$swal({
            toast: "true",
            position: "top-end",
            icon: "success",
            title: "Patch successfully",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        } else {
          this.$swal({
            type: "error",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: this.message,
          });
        }
      } catch (err) {
        this.loadingAction = false;
        this.$swal({
          type: "error",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          title: this.message,
        });
      }
    },
    async actionPatchOrder(line) {
      this.showConfirm(line);
    },
    isPremiumPackage(id) {
      const Offers = [
        43103,
        112772,
        44217,
        99551,
        90284,
        98675,
        98703,
        98704,
        112023,
        112024,
        112026,
        112027,
        112028,
        112029,
      ];
      const isValid = Offers.find((e) => e === id);
      return !!(isValid);
    },
  },
};
</script>

<style scoped>
.details {
  font-family: "Avenir Next", "effra", Helvetica, Arial, sans-serif;
}
.h-custom {
  min-height: 800px;
}
</style>
